module.exports = __webpack_public_path__ + "static/img/XC.62cb5cd8.svg";